// Whitelist of segment fields over companies_summary (alias c). Spec 08 §4.
export type FieldKind =
  | "text"
  | "number"
  | "bool"
  | "date"
  | "deal_stage"
  | "tag"
  | "campaign_open"
  | "campaign_click";
export type SegmentFieldDef = { kind: FieldKind; expr: string | null };

export const SEGMENT_FIELDS: Readonly<Record<string, SegmentFieldDef>> =
  Object.freeze({
    trade: { kind: "text", expr: "c.trade" },
    region: { kind: "text", expr: "c.region" },
    city: { kind: "text", expr: "c.city" },
    segment: { kind: "text", expr: "c.segment" },
    prospect_status: { kind: "text", expr: "c.prospect_status::text" },
    last_call_outcome: { kind: "text", expr: "c.last_call_outcome::text" },
    assigned_sales_id: { kind: "number", expr: "c.assigned_sales_id" },
    has_email: { kind: "bool", expr: "(c.email is not null)" },
    high_quality: { kind: "bool", expr: "c.high_quality" },
    fit_score: { kind: "number", expr: "c.fit_score" },
    created_at: { kind: "date", expr: "c.created_at" },
    date_added: { kind: "date", expr: "c.date_added::timestamptz" },
    last_called_at: { kind: "date", expr: "c.last_called_at" },
    last_email_at: { kind: "date", expr: "c.last_email_at" },
    deal_stage: { kind: "deal_stage", expr: null },
    tags: { kind: "tag", expr: null },
    opened_campaign: { kind: "campaign_open", expr: null },
    clicked_campaign: { kind: "campaign_click", expr: null },
  });

export const OPS_BY_KIND: Readonly<Record<FieldKind, readonly string[]>> =
  Object.freeze({
    text: ["eq", "neq", "in", "nin", "exists", "not_exists"],
    number: ["eq", "neq", "gt", "gte", "lt", "lte", "exists", "not_exists"],
    bool: ["eq"],
    date: ["gte", "lte", "days_since_gte", "exists", "not_exists"],
    deal_stage: ["eq", "in"],
    tag: ["contains"],
    campaign_open: ["eq"],
    campaign_click: ["eq"],
  });

export const SEGMENT_FIELD_NAMES: readonly string[] = Object.freeze(
  Object.keys(SEGMENT_FIELDS),
);
export const fieldDef = (field: string): SegmentFieldDef | null =>
  Object.hasOwn(SEGMENT_FIELDS, field) ? SEGMENT_FIELDS[field] : null;
